import React from "react";
const ItemDetailsRewardInformation = ({ rewardInfo }) => {
  return (
    <div className="item-details-reward-information-container">
      <p>{rewardInfo.name}</p>
      <p>{rewardInfo.description}</p>

      <div className="item-details-information-container">
        <div>
          <p>Point Per Paid IOU</p>
          <p>{rewardInfo.points}</p>
        </div>
        <div>
          <p>Point Required to Redeem</p>
          <p>{rewardInfo.pointsToRedeem}</p>
        </div>
      </div>
      <p className="item-details-reward-information-download-app-text">
        Please download the app to participate in this reward
      </p>
    </div>
  );
};

export default ItemDetailsRewardInformation;
